<div *ngIf="side !== 'none'">
    <app-support-select-subscription *ngIf="side === 'subscriptions'" (onSubscriptionSelected)="selectSubscription($event)"></app-support-select-subscription>
    <app-create-ticket-form *ngIf="side === 'ticket'" [subscription]="subscription" (onBack)="selectSubscription(null)"></app-create-ticket-form>
</div>